import { render } from "./WorkDataScreen.vue?vue&type=template&id=61955d29&scoped=true&lang=html"
import script from "./WorkDataScreen.vue?vue&type=script&lang=js"
export * from "./WorkDataScreen.vue?vue&type=script&lang=js"

import "./WorkDataScreen.vue?vue&type=style&index=0&id=61955d29&lang=css&scoped=true"

import exportComponent from "/Users/peterdevos/Apps/visma_reaction_game/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61955d29"]])

export default __exports__